import axios from 'axios';

export type WhatsAppDirection = 'INBOUND' | 'OUTBOUND';

export interface WhatsAppMessageDto {
  id: string;
  direction: WhatsAppDirection;
  fromPhone: string;
  toPhone: string;
  body: string | null;
  status: string;
  customerId: string | null;
  customerName: string | null;
  receivedAt: string;
  sentAt: string | null;
  aiIntent: string | null;
  aiSummary: string | null;
  aiConfidence: number | null;
  aiProvider: string | null;
  aiModel: string | null;
  aiError: string | null;
}

export interface PageResponse<T> {
  content: T[];
  totalElements: number;
  totalPages: number;
  number: number;
  size: number;
}

const BASE_PATH = '/api/services/reservare-be';

export async function fetchWhatsAppMessages(page = 0, size = 20): Promise<PageResponse<WhatsAppMessageDto>> {
  const response = await axios.get<PageResponse<WhatsAppMessageDto>>(`${BASE_PATH}/admin/whatsapp/messages`, {
    params: { page, size },
    withCredentials: true,
    headers: {
      'X-Auth': 'Auth0',
    },
  });
  return response.data;
}
